import { render, staticRenderFns } from "./StockchartMenu.vue?vue&type=template&id=5db40c20&scoped=true&"
import script from "./StockchartMenu.vue?vue&type=script&lang=js&"
export * from "./StockchartMenu.vue?vue&type=script&lang=js&"
import style0 from "./StockchartMenu.vue?vue&type=style&index=0&id=5db40c20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db40c20",
  null
  
)

export default component.exports